import { ProtocolConfig, ProtocolKey } from "@silo/types";
import { local } from "./local";
import { anvil } from "./anvil";
import { base } from "./base";
import { mainnetLegacy } from "./mainnet-legacy";
import { mainnetLlama } from "./mainnet-llama";
import { mainnetGrand } from "./mainnet-grand";
import { arbitrum } from "./arbitrum";
import { optimism } from "./optimism";
import { satisfies } from "effect/Function";
import { lrtbase } from "./lrtbase";

export const PROTOCOL_CONFIG = satisfies<Record<ProtocolKey, ProtocolConfig>>()(
  {
    mainnetLegacy,
    mainnetLlama,
    mainnetGrand,
    arbitrum,
    optimism,
    base,
    lrtbase,
    local,
    anvil,
  } as const
);
